import { ContactPage } from "./components/contact";

function Contact() {
    return (
        <>
            <ContactPage />
        </>
    );
}

export default Contact;